  import fbPixelEvent from "../../../data/fbPixelEvent"; // Adjust path if necessary, assuming it's sibling to tracking/
  
  /**
   * Creates an event data object for Facebook Pixel based on event name and data data.
   * @param {string} eventName - The name of the Facebook Pixel event.
   * @param {object} data - The data data containing information for the event.
   * @returns {object} The formatted event data object.
   */
  export function createEventObject(eventName, data) {
    const eventData = {};
    const expectedParams = fbPixelEvent[eventName] || [];
  
    // Set common defaults, which can be overridden by specific data.
    eventData.currency = data.currency || "IDR";
    eventData.content_type = data.content_type || "product";
    eventData.fbc = data.fbc; // Facebook Click ID from the browser
    eventData.fbp = data.fbp; // Facebook Browser ID from the browser
    eventData.event_time = data.event_time; // Facebook Browser ID from the browser
  
    // Populate eventData with expected parameters directly from the 'data' object.
    // The assumption is that 'data' already contains these properties with correct values.
    console.log({expectedParams, data})
    for (const paramName of expectedParams) {
      if (data[paramName] !== undefined) {
        eventData[paramName] = data[paramName];
      } else if (eventData[paramName] === undefined) {
        // For standard events, if a required parameter is missing, set to null
        // for consistency in pixel payload, allowing Facebook to identify missing data.
        eventData[paramName] = null;
      }
    }
    return eventData;
  }

  /**
   * @param {string} [scope] - Order identity (orderTrackingKey) so "once" is once per order, not once per tab.
   */
  export async function checkTrackingConversion(context, key, globalConversionSetting, scope) {
    const trackingConversion = context.trackingConversion === "global"
      ? globalConversionSetting
      : context.trackingConversion;
    const conversionSetting = trackingConversion || context.globalConversionSetting;

    if (conversionSetting === "once") {
      const result = checkSession(scope ? `${key}_${scope}` : key);
      if (result) return false;
    }

    return true;
  }
  
  export function checkSession(key) {
    try {
      if (sessionStorage.getItem(key)) {
        return true;
      }
      sessionStorage.setItem(key, true);
    } catch (error) {
      // storage blocked (private mode, some in-app browsers): send rather than lose the event
    }
    return false;
  }

  const ORDER_EVENT_PREFIX = 'orderEventSent:';
  const ORDER_EVENT_TTL_MS = 365 * 24 * 60 * 60 * 1000;
  const orderEventsSentThisPage = new Set();

  /**
   * One browser event per order: the same pixel never receives the same event for the same order
   * twice from this browser (a reloaded success page with "Every", or a checkout-page Purchase and a
   * success-page Purchase for the same pixel). Events not tied to an order (checkout page) follow the
   * seller's Once/Every setting only. When storage is blocked (private mode, some in-app browsers)
   * only this page view is covered, and the event is still sent.
   * @returns {boolean} true when the event should be sent now
   */
  export function claimOrderEvent(platform, pixelId, eventName, orderKey) {
    if (!orderKey) return true;
    const key = `${ORDER_EVENT_PREFIX}${platform}:${pixelId}:${eventName}:${orderKey}`;
    if (orderEventsSentThisPage.has(key)) return false;
    orderEventsSentThisPage.add(key);
    try {
      const now = Date.now();
      const sentAt = Number(localStorage.getItem(key));
      if (sentAt && now - sentAt < ORDER_EVENT_TTL_MS) return false;
      forgetExpiredOrderEvents(now);
      localStorage.setItem(key, String(now));
    } catch (error) {
      // storage blocked or full: never lose the event because of it
    }
    return true;
  }

  function forgetExpiredOrderEvents(now) {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && key.indexOf(ORDER_EVENT_PREFIX) === 0 && !(now - Number(localStorage.getItem(key)) < ORDER_EVENT_TTL_MS)) {
        localStorage.removeItem(key);
      }
    }
  }
